<div *ngIf="activeAddress$ | async as address" class="address">
  <div class="address-block">{{ address.formattedAddress }} , {{ address.appartment }}</div>
  <div class="address-details">
    <span *ngIf="address.entrance">Подъезд: {{ address.entrance }}</span>
    <span *ngIf="address.floor">Этаж: {{ address.floor }}</span>
    <span *ngIf="address.domofon">Домофон: {{ address.domofon }}</span>
  </div>
  <button class="address-change" sdButton type="outlined" size="s" (click)="openModal()">Изменить</button>
</div>
